<div id="information-banners" #banner>
  <app-processing-provider-banner></app-processing-provider-banner>
</div>
